import styled from "styled-components";

export const HeaderContainer = styled("div")`
  background: #0077b6;
  text-align: center;
  padding: 1.5rem;
  font-size: 2.1rem;
  font-weight: 500;
  img {
    width: 2.5rem;
  }
`;

export const HeaderContent = styled("div")`
  display: flex;
  justify-content: space-around;
`;